export const LANG_KEY_TO_LANGUAGE_MAPPING = new Map([
  ['en', 'en'],
  ['fr', 'fr'],
  ['it', 'it'],
]);

export const LANG_KEY_TO_LANGUAGE_LABEL_MAPPING = new Map([
  ['en', 'English'],
  ['fr', 'Français'],
  ['it', 'Italiano'],
]);

export const getLangKeyFromUrl = (pathname) => {
  const predicate = pathname.toLowerCase().trim();

  if (predicate.includes('/it/')) {
    return 'it';
  }

  if (predicate.includes('/fr/')) {
    return 'fr';
  }

  return 'en';
};

export const getRemainingLanguages = (languages, currentLangKey) =>
  languages.filter((l) => l !== currentLangKey);

export const getLangKeyFromBrowserSettings = (languages) => {
  const browserLanguage = navigator.language || navigator.userLanguage;
  return languages.langs.includes(browserLanguage) ? browserLanguage : 'en';
};
